import React, { Fragment } from 'react'
import { Intro, DragAndDrop, Voiceover } from 'cvs-core'
import image from '../../assets/images/U1-T1-10a.svg'
import voAudio from '../../assets/vo/Learn-Check-your-understanding-01.mp3'

const vo = {
  sources: [
    {
      src: voAudio,
    },
  ],
  transcript:
    'Ben could put himself at great risk by using e-cigarettes. Continue to check your understanding of the various risks and consequences of vaping or using e-cigarettes.',
}

const dragOptions = [
  'Damage to lungs, mouth, and throat',
  'Addiction',
  'Distrust from parents and teachers',
  'Losing friends',
  'Permanent changes to the decision-making prefrontal cortex',
  'Getting kicked off sports teams',
]

const HARM_TO_BRAIN = 'Harm to Brain'
const HARM_TO_BODY = 'Harm to Body'
const SOCIAL_CONSEQUENCE = 'Social Consequence'

const dropZones = [HARM_TO_BRAIN, HARM_TO_BODY, SOCIAL_CONSEQUENCE]

const dropZoneMessage = 'Drag elements here.'

const data = {
  dragOptions,
  dropZones,
  dropZoneMessage,
}
const correctInput = {
  [HARM_TO_BRAIN]: [dragOptions[1], dragOptions[4]],
  [HARM_TO_BODY]: [dragOptions[0]],
  [SOCIAL_CONSEQUENCE]: [dragOptions[2], dragOptions[3], dragOptions[5]],
}

const feedback = {
  success: {
    title: 'Great!',
    body:
      'Vaping/using e-cigarettes can dangerously affect your brain and body and also lead to negative social consequences.',
  },
  error: {
    title: 'Not Quite',
    body:
      'Vaping/using e-cigarettes can dangerously affect your brain and body and also lead to negative social consequences.',
  },
}

export default {
  title: 'Check Your Understanding',
  path: '/learn/check-your-understanding',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        title="Check Your Understanding"
        direction="Drag each element to the correct category."
        lead="Ben could put himself at great risk by using e-cigarettes. Continue to check your understanding of the various risks and consequences of vaping/using e-cigarettes."
        img={image}
      />
      <DragAndDrop
        data={data}
        correctInput={correctInput}
        feedback={feedback}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Learn/CheckYourUnderstanding.js